module.exports = __webpack_public_path__ + "static/media/random_house.537abd05.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/random_house.svg
// module id = 534
// module chunks = 0